import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'qumra-form',
  styleUrl: 'qumra-form.css',
  shadow: false,
})
export class QumraForm {
  @Prop() form: string;
  @State() schema: any = [];
  @State() dataValue: any = {}; 
  @State() loading: boolean = false;

  async componentDidLoad() {
    const waitForQumra = () => {
      return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
          if (window.Qumra && window.Qumra.forms && typeof window.Qumra.forms.getFormSchema === "function") {
            clearInterval(interval);
            resolve(true);
          }
        }, 1000);
  
       
        setTimeout(() => {
          clearInterval(interval);
          reject(new Error("Qumra library not loaded in time."));
        }, 10000);
      });
    };
  
    try {
      this.loading = true;
      await waitForQumra();
  
      const form = await window.Qumra.forms.getFormSchema(this.form);
  
      if (form.status === 200) {
        this.schema = form.data.data.schema;
      }
    } catch (error) {
      console.error("Error while loading Qumra library or schema:", error);
    } finally {
      this.loading = false;
    }
  } 

  handleChange = (key: string, value: any) => {
    const keyParts = key.split(/[.\[\]]+/).filter(Boolean); 

    if (keyParts.length > 1) {
      const newData = { ...this.dataValue }; 
      let currentData = newData;

      for (let i = 0; i < keyParts.length - 1; i++) {
        const part = keyParts[i];

        if (Array.isArray(currentData[part])) {
          currentData[part] = [...currentData[part]];
          currentData = currentData[part];
        } else {
          currentData[part] = { ...currentData[part] };
          currentData = currentData[part];
        }
      }

      currentData[keyParts[keyParts.length - 1]] = value;

      this.dataValue = newData; 
    } else {
      this.dataValue = {
        ...this.dataValue,
        [key]: value,
      };
    }
  }

  async submit() {
    try {
      this.loading = true;
      const res = await window.Qumra.forms.sendFormData(this.form, this.dataValue);
      if (res.status === 200) {
        window.Qumra.notify.success("تم الارسال بنجاح");
        this.dataValue = {};
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      window.Qumra.notify.error("فشل في إرسال البيانات");
    } finally {
      this.loading = false;
    }
  }

  render() {
    return (
      <div class="form-container">
        {this.loading ? (
          <div class="form-loading-container">
            <div class="form-loading"></div>
          </div>
        ) : (
          Object.values(this.schema).length > 0 ? (
            Object.entries(this.schema)?.map(([key, field]: [string, any]) => {
              switch (field.type) {
                case 'string':
                  return (
                    <qumra-input-text
                      key={key}
                      keyVal={key}
                      handleChange={this.handleChange}
                      label={field.title}
                      value={this.dataValue[key]}
                    />
                  );

                case 'file':
                  return (
                    <qumra-input-file
                      key={key}
                      keyVal={key}
                      handleChange={this.handleChange}
                      label={field.title}
                      value={this.dataValue[key]}
                    />
                  );

                default:
                  return null;
              }
            })
          ) : (
            <div class="form-loading-container">
              <div class="form-loading"></div>
            </div>
          )
        )}
       
        <button aria-label="UIform-btn-submit" class="form-btn-submit" onClick={this.submit.bind(this)} disabled={this.loading}>
          {this.loading ? 'جاري الإرسال...' : 'حفظ'}
        </button>
      </div>
    );
  }
}